import { yupResolver } from "@hookform/resolvers/yup";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import React, { useState } from "react";
import { Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import VisitBasicInformation from "./VisitBasicInformation";
import VisitHeader from "./VisitHeader";
import { format } from "date-fns";
import VisitLabReports from "./VisitLabReports";
import { PatientVisitAPI } from "api";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";

const schema = yup.object({
  patientId: yup.string(),
  clinicId: yup.string(),
  doctorId: yup.string(),
  visitDate: yup.string(),
  diagnosis: yup.string(),
  notes: yup.string(),
  followupRequired: yup.boolean(),
  nextVisitOn: yup.string(),
  visitFee: yup.string(),
  prescriptions: yup
    .array()
    .of(
      yup.object({
        medicationName: yup.string().required("Medication name is required"),
        dosage: yup.string().required("Dosage is required"),
        frequency: yup.string().required("Frequency is required"),
        duration: yup.string().required("Duration is required"),
        instructions: yup.string().required("Instructions are required"),
      })
    )
    .required("Prescriptions are required"),
  labTests: yup.array().of(
    yup.object({
      testName: yup.string(),
      testDate: yup.string(),
      results: yup.string(),
      normalRange: yup.string(),
      notes: yup.string(),
      fileName: yup.string(),
      filePath: yup.string(),
    })
  ),
  // .required("LabTests are required"),
});
// .required();

const AddVisit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [key, setKey] = useState("basicInfo");

  const submittedValues = {};
  const methods = useForm({
    shouldFocusError: true,
    resolver: yupResolver(schema),
    defaultValues: { labTests: [{}], prescriptions: [{}] },
  });
  const { handleSubmit, reset, setValue } = methods;

  // console.log(location.state);

  const onSubmit = async (data) => {
    let patientId =
      location.state && !location.state.parentId1
        ? location.state?.patientId
        : location.state?.parentId1;

    let myData = {
      ...data,
      patientId: patientId,
      visitDate: new Date().toISOString(),
      prescriptions: (data.prescriptions || []).map((item) => ({
        ...item,
        patientId: patientId,
      })),
      labTests: (data.labTests || []).map((item) => ({
        ...item,
        patientId: patientId,
        fileName: item.fileName ?? "",
        filePath: item.filePath ?? "",
      })),
    };

    console.log(myData);

    // console.log("location.state", location.state);

    if (!location?.state?.patientId) {
      toast.error("Please add Patient first", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      return;
    }
    try {
      await PatientVisitAPI.post(myData);
      toast.success("Record updated successfully", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  // useEffect(() => {
  //   if (location.state) {
  //     reset(location.state);
  //   }
  // }, []);

  return (
    <>
      <div className="py-2">
        <BreadCrumb />
      </div>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">
            <Col xs={12}>
              <VisitHeader />
            </Col>
            <Col lg={12}>
              <Card className="mb-3 py-2">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                >
                  <Tab
                    eventKey="basicInfo"
                    title="Prescriptions"
                    className="p-3"
                  >
                    <VisitBasicInformation />
                  </Tab>
                  <Tab
                    eventKey="lab-reports"
                    title="Lab Reports"
                    className="p-3"
                  >
                    <VisitLabReports />
                  </Tab>
                </Tabs>
              </Card>

              {/* <ProductUpload /> */}
              {/* <ProductDetails /> */}
              {/* <ProductSpecifications /> */}
            </Col>
            {/* <Col xs={12}>
              <CategoryFooter />
            </Col> */}
          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddVisit;
